import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { Bolt, Images } from "lucide-react";

export const ServiceCard = ({ service }) => {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);

  return (
    <Card className="group bg-white/5 backdrop-blur-2xl border-white/10 hover:bg-white/10 transition-colors">
      <CardHeader onClick={() => setOpen((v) => !v)} className="cursor-pointer">
        <CardTitle className="flex items-center justify-between text-white">
          {service.title}
          <Bolt className="w-5 h-5 text-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity" />
        </CardTitle>
        <CardDescription className="text-white/70">{service.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2 flex-wrap mb-2">
          {service.highlights?.map((h, i) => (
            <span key={i} className="px-3 py-1 rounded-full bg-white/10 text-white/80 text-xs border border-white/15">{h}</span>
          ))}
        </div>
        {open && (
          <div className="mt-3">
            {service.images?.length ? (
              <div className="grid grid-cols-3 gap-2">
                {service.images.map((url, i) => (
                  <img
                    key={i}
                    src={url}
                    alt="serviço"
                    className="h-24 w-full object-cover rounded cursor-pointer hover:opacity-90"
                    onClick={() => setPreview(url)}
                  />
                ))}
              </div>
            ) : (
              <div className="text-white/60 text-sm flex items-center gap-2">
                <Images className="w-4 h-4" /> Sem imagens adicionadas
              </div>
            )}
          </div>
        )}
      </CardContent>

      <Dialog open={!!preview} onOpenChange={() => setPreview(null)}>
        <DialogContent className="bg-[#0b1b34] border-white/10 p-2">
          {preview && <img src={preview} alt="preview" className="w-full h-auto rounded" />}
        </DialogContent>
      </Dialog>
    </Card>
  );
};
